import React, { useState } from "react";
import SVGIcons from "../input/icons.json";
import ToggleInput from "./toggle";
import ModalInput from "./modal";
import TextInput from "./text";
import Button from "./button";
import TextareaInput from "./textarea";
import SVG from "react-inlinesvg";
import "./icon.scss";
import { INPUT_LIMITS } from "../input-limits";
const isSvg = require("is-svg");

function IconInput({
  activeIcon,
  setActiveIcon,
  hideRemoveButton,
  supportCustom = false,
  hasCustomIcon = false,
  setHasCustomIcon,
  customIcon,
  setCustomIcon,
}) {
  const [isOpen, setOpen] = useState(false);
  const openModal = () => setOpen(true);
  const closeModal = () => setOpen(false);

  const [searchValue, setSearchValue] = useState("");

  function renderSingleIcon(keyname, ignoreCustom = false) {
    if (!ignoreCustom) {
      if (hasCustomIcon && customIcon && isSvg(customIcon)) {
        return <SVG src={customIcon} />;
      }
    }
    if (keyname && SVGIcons[keyname]) {
      return <SVG title={keyname} src={SVGIcons[keyname]} />;
    }
    return null;
  }

  function resetIcon() {
    setActiveIcon("");
    if (supportCustom) {
      setHasCustomIcon(false);
      setCustomIcon("");
    }
  }

  function searchPositive(keyname) {
    if (searchValue && searchValue.length > 3) {
      const stringArray = searchValue.trim().split(/\s+/);
      for (let i = 0; i < stringArray.length; i++) {
        var substr = stringArray[i];
        if (!keyname.includes(substr.toLowerCase())) {
          return false;
        }
      }
      return true;
    }
    return true;
  }

  return (
    <>
      {!(activeIcon || (supportCustom && hasCustomIcon)) && (
        <>
          <div className={`grigora-ui-kit-icons-selected`}>
            <Button variant="primary" onClick={openModal}>
              Select Icon
            </Button>
          </div>
          <br></br>
          {supportCustom && (
            <ToggleInput
              label={"Custom SVG Icon"}
              value={hasCustomIcon}
              onChange={() => setHasCustomIcon(!hasCustomIcon)}
            />
          )}
        </>
      )}
      {(activeIcon || (supportCustom && hasCustomIcon)) && (
        <>
          <div className={`grigora-ui-kit-icons-selected-svg `}>
            {renderSingleIcon(activeIcon)}
          </div>
          <div className={`grigora-ui-kit-icons-selected`}>
            <Button
              className="text-black text-xs"
              variant="secondary"
              onClick={openModal}
            >
              {"Change"}
            </Button>
            {!hideRemoveButton && (
              <Button
                className="text-black text-xs"
                variant="secondary"
                onClick={resetIcon}
              >
                {"Remove"}
              </Button>
            )}
          </div>
          <br></br>
          {supportCustom && (
            <ToggleInput
              label={"Custom SVG Icon"}
              value={hasCustomIcon}
              onChange={() => setHasCustomIcon(!hasCustomIcon)}
            />
          )}
          {hasCustomIcon && (
            <TextareaInput
              minLength={INPUT_LIMITS["custom-code"].minlength}
              maxLength={INPUT_LIMITS["custom-code"].maxlength}
              label={"SVG Icon HTML"}
              value={customIcon}
              onChange={setCustomIcon}
            />
          )}
        </>
      )}

      <ModalInput
        isOpened={isOpen}
        onOutsideClick={() => {
          closeModal();
        }}
        overlayClassName={`grigora-ui-kit-icon-picker-modal-overlay`}
      >
        <div className="bg-white rounded-[21px] p-3 flex flex-col h-[80vh] overflow-hidden">
          <div className="grigora-ui-kit-icon-picker-search">
            <TextInput
              minLength={INPUT_LIMITS["search"].minlength}
              maxLength={INPUT_LIMITS["search"].maxlength}
              isResetVisible={false}
              placeholder="Search for icons..."
              value={searchValue}
              onChange={(e) => setSearchValue(e.target.value)}
              className={"grigora-ui-kit-icon-picker-search__text"}
            />
          </div>
          <div className="grigora-ui-kit-icon-picker flex-1 flex items-center flex-wrap">
            {Object.keys(SVGIcons).map((keyName, i) => {
              if (searchPositive(keyName)) {
                return (
                  <div
                    key={`${keyName}-${i}`}
                    className={`grigora-ui-kit-svg-icon ${
                      activeIcon === keyName ? "active" : ""
                    }`}
                    onClick={(e) => {
                      if (e.detail == 1) {
                        if (activeIcon === keyName) {
                          if (!hideRemoveButton) {
                            setActiveIcon("");
                          }
                        } else {
                          setActiveIcon(keyName);
                        }
                      } else {
                        setActiveIcon(keyName);
                        closeModal();
                      }
                    }}
                  >
                    {renderSingleIcon(keyName, true)}
                  </div>
                );
              }
              return null;
            })}
          </div>
        </div>
      </ModalInput>
    </>
  );
}

export default IconInput;
